
export function textToHTML( text ) {
    const container = document.createElement( 'div' );
    container.innerHTML = text;
    return container.firstElementChild;
}